import { Controller } from "@hotwired/stimulus"

// Tell the server which timezone this browser is in.
//
// Without this, a per-user zone is only as good as a settings page nobody
// visits — and the symptom it fixes (the app thinking today is yesterday)
// is exactly the kind of thing a user reports as "the site is broken"
// rather than "my timezone is wrong".
//
// Intl reports IANA names ("Pacific/Auckland"), which is what Rails stores.
export default class extends Controller {
  static values = { url: String, current: String }

  connect() {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!detected || detected === this.currentValue) return

    // Fire and forget. Nothing on the page depends on the response: the new
    // zone applies from the next request, and a failure just leaves the
    // previous one in place.
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
      },
      body: JSON.stringify({ time_zone: detected })
    }).catch(() => {})
  }
}
